// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dc-opinion[data-v-5d361125]{padding:4rem 0}@media only screen and (min-width: 737px){.dc-opinion[data-v-5d361125]{padding:9rem 0}}.dc-opinion-header[data-v-5d361125]{margin-bottom:4rem}@media only screen and (min-width: 737px){.dc-opinion-header[data-v-5d361125]{margin-bottom:6rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
